import {
    Box,
    Button,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel,
    FormLabel,
    TextField,
    Typography,
    FormHelperText
} from "@mui/material";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
export default function EligibilityForm({

    data,
    errors,
    handleChange,
    onBack,
    onContinue

}) {

    return (
            <Paper
                elevation={3}
                sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography
                    variant="h4"
                    gutterBottom
                >
                    Eligibility
                </Typography>

                <Typography
                    variant="body1"
                    sx={{ mb: 4, color: "rgba(0,0,0,0.6)",}}
                >
                    Please answer the following questions before continuing your application.
                </Typography>

                {/* Right to Work */}

                <FormControl
                    fullWidth
                    error={!!errors.eligibilityStatus}
                    sx={{ mb: 4 }}
                >

                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>
                        Please select which group best represents your current eligibility status:
                    </FormLabel>

                    <RadioGroup
                        name="eligibilityStatus"
                        value={data.eligibilityStatus}
                        onChange={handleChange}
                    >

                        <FormControlLabel
                            value="UK/EU Citizen"
                            control={<Radio />}
                            label="UK/EU Citizen"
                        />

                        <FormControlLabel
                            value="EEA Citizen"
                            control={<Radio />}
                            label="EEA Citizen"
                        />

                        <FormControlLabel
                            value="Ancestral Visa"
                            control={<Radio />}
                            label="Ancestral Visa"
                        />

                        <FormControlLabel
                            value="Tier 1 (General Visa)"
                            control={<Radio />}
                            label="Tier 1 (General Visa)"
                        />

                        <FormControlLabel
                            value="Tier 2 (Employer Sponsored Visa)"
                            control={<Radio />}
                            label="Tier 2 (Employer Sponsored Visa)"
                        />

                        <FormControlLabel
                            value="Student Visa"
                            control={<Radio />}
                            label="Student Visa"
                        />

                        <FormControlLabel
                            value="Other"
                            control={<Radio />}
                            label="Other"
                        />

                        <FormControlLabel
                            value="I am not eligible to work in the UK"
                            control={<Radio />}
                            label="I am not eligible to work in the UK"
                        />

                    </RadioGroup>

                    {errors.eligibilityStatus && (

                        <Typography
                            color="error"
                            variant="caption"
                        >
                            {errors.eligibilityStatus}
                        </Typography>

                    )}

                </FormControl>

                {data.eligibilityStatus === "Other" && (

                    <TextField
                        fullWidth
                        sx={{ mb: 4 }}
                        label="Please specify"
                        name="eligibilityStatusOther"
                        value={data.eligibilityStatusOther}
                        onChange={handleChange}
                        error={Boolean(errors.eligibilityStatusOther)}
                        helperText={errors.eligibilityStatusOther}
                    />

                )}

                {/* Salary */}

                <TextField
                    fullWidth
                    sx={{ mb: 4 }}
                    label="Please state your required salary range"
                    name="salaryRange"
                    value={data.salaryRange}
                    onChange={handleChange}
                    placeholder="e.g. £35,000 or £18 per hour"
                    error={Boolean(errors.salaryRange)}
                    helperText={errors.salaryRange}
                />

                {/* CSCS */}

                <FormControl
                    fullWidth
                    error={Boolean(errors.hasCscsCard)}
                    sx={{ mb: 3 }}
                >

                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>
                        Do you hold a valid CSCS Card?
                    </FormLabel>

                    <RadioGroup
                        row
                        name="hasCscsCard"
                        value={String(data.hasCscsCard)}
                        onChange={handleChange}
                    >

                        <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Yes"
                        />

                        <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="No"
                        />

                    </RadioGroup>
                    <FormHelperText>
                        {errors.hasCscsCard}
                    </FormHelperText>
                </FormControl>

                {data.hasCscsCard === "true" && (

                    <TextField
                        select
                        fullWidth
                        sx={{ mb: 4 }}
                        label="Card Type"
                        name="cscsCardType"
                        value={data.cscsCardType}
                        onChange={handleChange}
                        error={Boolean(errors.cscsCardType)}
                        helperText={errors.cscsCardType}
                    >

                        <MenuItem value="cscs">CSCS</MenuItem>

                        <MenuItem value="cpcs">
                            CPCS (NOCN)
                        </MenuItem>

                        <MenuItem value="cisrs">
                            CISRS (NOCN)
                        </MenuItem>

                        <MenuItem value="ecs">
                            ECS
                        </MenuItem>

                        <MenuItem value="skillcard">
                            SKILLcard
                        </MenuItem>

                        <MenuItem value="emss">
                            EMSS - Safety Passport
                        </MenuItem>

                        <MenuItem value="gqa">
                            GQA
                        </MenuItem>

                        <MenuItem value="jibpmes">
                            JIB
                        </MenuItem>

                        <MenuItem value="other">
                            Other
                        </MenuItem>

                    </TextField>

                )}

                {/* Driving Licence */}

                <FormControl
                    fullWidth
                    error={Boolean(errors.hasDrivingLicence)}
                    sx={{ mb: 3 }}
                >

                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>
                        Do you hold a current drivers license?
                    </FormLabel>

                    <RadioGroup
                        row
                        name="hasDrivingLicence"
                        value={String(data.hasDrivingLicence)}
                        onChange={handleChange}
                    >

                        <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Yes"
                        />

                        <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="No"
                        />

                    </RadioGroup>
                     <FormHelperText>
                        {errors.hasDrivingLicence}
                    </FormHelperText>
                </FormControl>

                {data.hasDrivingLicence === "true" && (

                    <>

                        <FormControl
                            fullWidth
                            error={Boolean(errors.endorsements)}
                            sx={{ mb: 3 }}
                        >

                            <FormLabel sx={{color: "rgba(0,0,0,1)"}}>
                                Do you have any endorsements on your license?
                            </FormLabel>

                            <RadioGroup
                                row
                                name="endorsements"
                                value={String(data.endorsements)}
                                onChange={handleChange}
                            >

                                <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label="Yes"
                                />

                                <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label="No"
                                />

                            </RadioGroup>
                            <FormHelperText>
                                {errors.endorsements}
                            </FormHelperText>
                        </FormControl>

                    </>

                )}

                {data.endorsements === "true" && (

                    <TextField
                        multiline
                        rows={4}
                        fullWidth
                        sx={{ mb: 4 }}
                        label="Please provide endorsement details"
                        name="endorsementsDetails"
                        value={data.endorsementsDetails}
                        onChange={handleChange}
                        error={Boolean(errors.endorsementsDetails)}
                        helperText={errors.endorsementsDetails}
                    />

                )}

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width:"100%",
                        mt: 5
                    }}
                >

                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>

                    <Button
                        className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>

                </Box>

            </Paper>

    );

}